import React from 'react';
import './FilterSelect.css';

/**
 * Composant réutilisable pour les selects de filtres
 * @param {string} name - Nom du champ (pour onChange)
 * @param {string} value - Valeur contrôlée
 * @param {function} onChange - Fonction appelée au changement
 * @param {array} options - Tableau d'options [{value, label}] ou [{id, nom}]
 * @param {string} placeholder - Texte du placeholder (défaut: "Sélectionner...")
 * @param {string} className - Classes CSS supplémentaires (pour largeur spécifique)
 * @param {string} width - Largeur personnalisée
 */
const FilterSelect = ({
  name,
  value,
  onChange,
  options = [],
  placeholder = 'Sélectionner...',
  className = '',
  width,
}) => {
  const style = width ? { width } : {};
  const selectClass = `filter-select ${className}`.trim();

  // Normaliser les options : supporte {value, label} ou {id, nom}
  const normalizedOptions = options.map(opt => {
    if (opt.value !== undefined && opt.label !== undefined) {
      return { value: opt.value, label: opt.label };
    }
    if (opt.id !== undefined && opt.nom !== undefined) {
      return { value: opt.id, label: opt.nom };
    }
    // Si c'est déjà normalisé ou autre format, essayer de l'utiliser tel quel
    return opt;
  });

  return (
    <select
      name={name}
      value={value}
      onChange={onChange}
      className={selectClass}
      style={style}
    >
      {placeholder && (
        <option value="">{placeholder}</option>
      )}
      {normalizedOptions.map((option, index) => {
        // Compute a safe display label that always results in a string
        const displayLabel = option.label ?? option.nom;
        const safeLabel = displayLabel != null ? String(displayLabel) : '';
        
        return (
          <option key={option.value ?? index} value={option.value}>
            {safeLabel}
          </option>
        );
      })}
    </select>
  );
};

export default FilterSelect;

